import script from "./PCTManagementView.vue?vue&type=script&setup=true&lang=js"
export * from "./PCTManagementView.vue?vue&type=script&setup=true&lang=js"

import "./PCTManagementView.vue?vue&type=style&index=0&id=1a014c93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a014c93"]])

export default __exports__